import React, { useEffect } from "react";
import ViewMaster from "../../Components/ViewMaster/ViewMaster";

function Contact() {
  useEffect(() => {
    document.title = "Zesty games | Contact Us";
  }, []);
  return (
    <>
      <div>
        <div className="bgContent" style={{ "background-color": "#ffffff" }}>
          <div className="container py-4 text-white fs-20">
            {/* <div className="mb-4 pb-3">
              <h4 className="DescriptionHeading"> Contact US </h4>
              <p> info@ZestyGame.com</p>
            </div> */}
            <div className="mt-4 txblack">
              <h4 className="DescriptionHeading">
                {" "}
                Do you have any questions? Get in Touch
              </h4>
              <p>
                We respect and protect intellectual property rights (IPR) at
                Zesty. For numerous games on our platform, we own the
                intellectual property rights. We have obtained licenses from the
                appropriate copyright holders for a number of titles. In certain
                cases, copyright information was either impossible to find or is
                now inaccessible because of heavy internet traffic.
              </p>

              <p>
                Some games are only used in certain circumstances, and Zesty
                complies with all the requirements that we could find.
              </p>

              <p>
                We don't make any changes to the games' source code. All
                attributions, brand names, and allusions to the original
                webpages are still there. Please get in touch with us straight
                once and provide the following details if you think that Zesty
                has violated any of your copyright or intellectual property
                rights:
              </p>

              <p>
                - The signature—either physical or digital—of the owner of the
                intellectual property or a designated agent.
              </p>
              <p>
                - A thorough explanation of the violated intellectual property,
                together with an account of the infringement action.
              </p>
              <p>
                - Where the illegal content is located (for example, the URL on
                Zesty where it is posted).
              </p>
              <p>
                - A copy of the license allowing you, in the event that you are
                not the original owner, to safeguard intellectual property.
              </p>
              <p>
                - Specifics regarding the location of the aforementioned item on
                our website.
              </p>
              <p>
                - A declaration stating that you think the copyright owner,
                their agent, or the law has approved the disputed use.
              </p>
              <p>- Your entire name and contact information.</p>

              <p>
                Kindly forward the aforementioned details to
                infoZesty@gmail.com. After reviewing your submission, we'll get
                right to whatever needs to be done. We will respond to you
                within seven days.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default ViewMaster(Contact);
